import React, { useEffect, useState } from 'react';
import { authenticateUser } from '../../services/authService';
import './acknowledgePage.scss';
import LoadingIndicator from '../LoadingIndicator'; 

const AcknowledgePage = () => {
  const [message, setMessage] = useState({ title: '', message: '' });
  const [isLoading, setIsLoading] = useState(false);
  const [showSignIn, setShowSignIn] = useState(true);

  

  // useEffect(() => {
  //   const queryParams = new URLSearchParams(window.location.search);
  //   const userId = queryParams.get('userId');
  //   const token = queryParams.get('token');

  //   const checkAuthentication = async () => {
  //     setIsLoading(true);
  //     try {
  //       if (userId && token) {
  //         const response = await authenticateUser(userId, token);
  //         if (response && response.title && response.message) {
  //           setMessage({ title: response.title, message: response.message });
  //           if (
  //             response.message?.toLowerCase().includes('deactivated') ||
  //             response.message?.toLowerCase().includes('validation time is elapsed')
  //           ) {
  //             setShowSignIn(false);
  //           } else {
  //             setShowSignIn(true);
  //           }
  //         }
  //       }
  //     } catch (error) {
  //       setMessage({
  //         title: 'Bad Request',
  //         message: 'Invalid or expired token'
  //       });
  //       setShowSignIn(false);
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };

  //   checkAuthentication();
  // }, []);

  useEffect(() => {
    // Always clear the flag first
    sessionStorage.removeItem('isDeactivatedUser');
    window.dispatchEvent(new Event('deactivationChange'));

    const queryParams = new URLSearchParams(window.location.search);
    const userId = queryParams.get('userId');
    const token = queryParams.get('token');
    const checkAuthentication = async () => {
      setIsLoading(true);
      try {
        if (userId && token) {
          const response = await authenticateUser(userId, token);
          if (response && response.title && response.message && response.status) {
            setMessage({ title: response.title, message: response.message });
            if (response.status === 'N') {
              setShowSignIn(false);
              // Set a flag for deactivated user
              sessionStorage.setItem('isDeactivatedUser', 'Y');
              window.dispatchEvent(new Event('deactivationChange'));
            } else {
              setShowSignIn(true);
              sessionStorage.setItem('isDeactivatedUser','N');
              window.dispatchEvent(new Event('deactivationChange'));
            }
          }
        }
      } catch (error) {
        setMessage({
          title: 'Bad Request',
          message: 'Invalid or expired token'
        });
        setShowSignIn(false);
        sessionStorage.setItem('isDeactivatedUser', 'N');
        window.dispatchEvent(new Event('deactivationChange'));
      } finally {
        setIsLoading(false);
      }
    };

    checkAuthentication();
    return () => {
      console.log("Clean Up started")
      sessionStorage.removeItem('isDeactivatedUser');
      window.dispatchEvent(new Event('deactivationChange'));
    };

  }, []);

  const handleSignIn = () => {
    window.location.href = '/login';
  };

  return (
    <div className="ack-container ack-center-bg">
      {isLoading ? (
        <LoadingIndicator />
      ) : (
        <div className="ack-content">
          <div className='heading-content ack-title'>
            {message.title}
            {/* {"Thank you, you are all set!"} */}
          </div>
          <div className="ack-message">
            {message.message}
            {/* {"Your account has been successfully verified. Enjoy seamless access to all Etihad Cargo’s online services."} */}
          </div>
          <div className="button-group ack-btn-group">
            <button className="close-btn" onClick={() =>  window.close()}>
              Close
            </button>
            {showSignIn && (
              <button className="sign-in-btn" onClick={handleSignIn}>
                Sign In
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default AcknowledgePage;